import React from "react";
import { PieChart, Pie } from "recharts";


const CustomLabel = ({ viewBox,total }) => {
    
  const { cx, cy } = viewBox;
  return (
    <text x={cx} y={cy} textAnchor="middle" dominantBaseline="central">
      <tspan x={cx} dy="-30" fill=" #737780" fontSize="24" >Total</tspan>
      <tspan x={cx} dy="25" fill=" #0F3040" fontSize="24" fontWeight="bold">{total}</tspan>
    </text>
  );
};

// this props are for the chart data only for the example
const DonutChart = ({spent,remaining,/*nonAllocated=2700}*/}) => {
    const total = spent + remaining ;
    let start= 0;
    let end= 360;
    let a= 0;
    let b= 0;
    let data = [];
    
    if(total>0){
      a= (remaining/total)*360;
      b= a + (spent / total) * 360 ;
    
    
    data = [
      { name: "Yellow", value: remaining, color: "#FFC44D", outerRadios:95 ,startAngle:start, endAngle:a },   // Yellow
      { name: "Blue", value: spent, color: " #16C2F3", outerRadios:85, startAngle:a, endAngle:b },     // Light Blue
      { name: "Dark Blue", value: remaining, color: "#0F3040", outerRadios:85, startAngle:b, endAngle:end } // Dark Blue
    ];

    }else
    data=[
      { name: "Gray", value: 1,color: "#ececec", outerRadios: 95,startAngle: 0,endAngle: 360,} 
    ]


  return (
    <PieChart width={260} height={220}>
      {
        data.map((entry, index) => (
          <Pie
            key={`slice-${index}`}
            data={[entry]}
            cx={125}
            cy={100}
            innerRadius={50}
            outerRadius={entry.outerRadios}
            startAngle={entry.startAngle}
            endAngle={entry.endAngle}
            fill={entry.color}
            paddingAngle={0}
            dataKey="value"
            stroke="none"
          />
        ))
      }
      <svg width="250" height="250">
    <CustomLabel viewBox={{ cx: 125, cy: 125 }} total={Math.round(total)}/>
  </svg>
    </PieChart>
  );
};

export default DonutChart;

